import React from 'react';
import PropTypes from 'prop-types';

const Select = ({
  options, description, onChange, name, value,
}) => (
  <select value={value || 'description'} name={name} onChange={onChange}>
    {description && (
      <option disabled value="description">
        {description}
      </option>
    )}
    {options.map(option => (
      <option value={option.value} key={option.value}>
        {option.text}
      </option>
    ))}
  </select>
);

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  description: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Select.defaultProps = {
  description: null,
  onChange: () => {},
  name: '',
  value: '',
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/index.js